"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var action_dto_1 = require("./action.dto");
/**
 * Class represents workflow's action's detailed info
 */
var ActionDetailDto = /** @class */ (function (_super) {
    __extends(ActionDetailDto, _super);
    function ActionDetailDto(id, name, description, targetStateId, initialStateId, templateId, formId) {
        var _this = _super.call(this, id, name, description, initialStateId, targetStateId, formId) || this;
        _this._templateId = templateId;
        return _this;
    }
    /**
     * Get action's template id
     * @returns {number}
     */
    ActionDetailDto.prototype.getTemplateId = function () {
        return this._templateId;
    };
    ActionDetailDto.prototype.toJsonObject = function () {
        var actionObject = _super.prototype.toJsonObject.call(this);
        actionObject['templateId'] = this._templateId;
        return actionObject;
    };
    ActionDetailDto.prototype.toJson = function () {
        return JSON.stringify(this.toJsonObject());
    };
    return ActionDetailDto;
}(action_dto_1.ActionDto));
exports.ActionDetailDto = ActionDetailDto;
//# sourceMappingURL=actiondetail.dto.js.map